import React from 'react'
import { Box, Link, Stack } from '@mui/material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import VisionCoverNotice from './VisionCoverNotice'

// Story 213 — what is left on screen while the vigilance covers the whole app (mode ALL, RN21): the one cover template
// of C11.8 and, discreet at the bottom, logging out. MIC content is not under it: the guard unmounted it.
const VisionOverlay = ({ state, cameraFailure, onBack, onLogout }) => {
  const { t_ } = useSmartTranslation()

  return (
    <Box
      data-testid='vision-overlay'
      data-reason={state.coverReason}
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        bgcolor: '#262626',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3
      }}
    >
      <Stack spacing={1.5} alignItems='center' sx={{ maxWidth: 640, textAlign: 'center' }}>
        <VisionCoverNotice state={state} cameraFailure={cameraFailure} onBack={onBack} />
      </Stack>
      <Link
        href='#'
        underline='always'
        onClick={(event) => {
          event.preventDefault()
          onLogout()
        }}
        sx={{ position: 'absolute', bottom: 24, fontSize: 13, color: '#A8A8A8', textDecoration: 'underline', textDecorationColor: 'inherit', '&:hover': { color: '#E6E6E6' } }}
      >
        {t_('Log out')}
      </Link>
    </Box>
  )
}

export default VisionOverlay
